export default __webpack_public_path__ + "images/0xfb98b335551a418cd0737375a2ea0ded62ea213b.png";